var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form"},[_c('Input',{staticClass:"form__input",attrs:{"placeholder":"Digite a tarefa"},model:{value:(_vm.taskTitle),callback:function ($$v) {_vm.taskTitle=$$v},expression:"taskTitle"}}),_c('Button',{attrs:{"primary":""},on:{"click":_vm.clickAction}},[_vm._v(" Adicionar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }